import { exists } from '@/api'

export interface ReferenceCreateImageRequest {
  referenceImageMasterId: number
}

export function ReferenceCreateImageFromJSON(
  json: any
): ReferenceCreateImageRequest {
  return ReferenceCreateImageJSONTyped(json)
}

export function ReferenceCreateImageJSONTyped(
  json: any
): ReferenceCreateImageRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    referenceImageMasterId: exists(json, 'reference_image_master_id')
      ? json.reference_image_master_id
      : 0
  }
}

export function ReferenceCreateImageToJSON(
  value?: ReferenceCreateImageRequest | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    reference_image_master_id: value.referenceImageMasterId
  }
}
